import React from 'react'
import { Chart } from 'react-google-charts';
import Spinner from '../../common/Spinner/Spinner';

const DeliveredResourcePieChart = ({data, totalResourcesDelivered, entrepreneursCount, isGetAllDeliveredCountLoading, isComplianceLoading, isMarketConnectLoading, isExpertConsultationLoading, isGroupKnowledgeSessionLoading, isBlrpLoading}) => {

    const chartData = [['Resource', 'Count'], ...data];

  return (
    <div>
    {
        // data.length > 1 ?
            <div style={{
                height: "55vh",
                // border: "3px solid",
            }}>
                <div className={`${(isGetAllDeliveredCountLoading || isComplianceLoading || isMarketConnectLoading || isExpertConsultationLoading || isGroupKnowledgeSessionLoading || isBlrpLoading) ? "set-opacity" : ""}`} style={{ height: "100%", boxSizing: "border-box" }}>
                    {(isGetAllDeliveredCountLoading || isComplianceLoading || isMarketConnectLoading || isExpertConsultationLoading || isGroupKnowledgeSessionLoading || isBlrpLoading)? <Spinner className="center" /> : ""}
                    <Chart
                        width={'100%'}
                        height="100%"
                        chartType="PieChart"
                        loader={
                            <div className='d-flex align-items-center justify-content-center flex-column'
                style={{
                    // border: "2px solid black",
                    // borderRadius: "15px",
                    height: '50vh'
                }}>
                Loading...
            </div>
                        }
                        data={chartData}
                      options={{
                        backgroundColor:"#ddd",
                        // title: 'Resource Delivered',
                        title: `${totalResourcesDelivered} resources delivered to ${entrepreneursCount ? entrepreneursCount : 0} entrepreneurs`,
                        titleTextStyle: {
                          fontSize: 10,
                          bold: true,
                          color: "#333",
                        },
                        chartArea: {
                            left: "15%",  // Centers the chart horizontally
                            width: "78%", // Adjust width to allow space for the title
                            height: "50%", // Reduce height so title remains inside
                            top: 80, // Moves the chart down, keeping title inside
                        },
                      }}
                    />
                </div>
            </div>

            // :
            // <div className='d-flex align-items-center justify-content-center flex-column'
            //     style={{
            //         border: "2px solid black",
            //         // borderRadius: "15px",
            //         height: '50vh'
            //     }}>
            //     Loading...
            // </div>
    }
</div>
  )
}

export default DeliveredResourcePieChart
